<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <div style="position: absolute;top:10px;right:20px;z-index: 99">
        <div>
          <el-checkbox v-model="checked" style="padding-left:16px;">每60秒刷新当前页面</el-checkbox>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item,index) in acceeptList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <finance-seach
        :column-option="bankDrafmonery"
        @onSearch="getList"
        ref="clearSeachInfo"
        :timer-array="['billDate','billEnddate','createDate','processDate']"
        :expression-array="['billMoney']"
      >
        <div class="search_rightitem" v-show="activeName === '1'">
          <el-button
            type="primary"
            :disabled="!list.some(ele=>ele.extract===1)"
            @click="onBatch"
          >批量认领</el-button>
        </div>
      </finance-seach>

      <div class="box-table" :style="{height: financeTableHeight + 'px'}">
        <el-table
          border
          ref="tableRef"
          :data="list"
          type="reset"
          :max-height="financeTableHeight"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            key="1"
            fixed
            type="selection"
            :selectable="selectableFun"
            width="35"
            v-if="activeName==='1'"
          ></el-table-column>
          <el-table-column label="收款编号">
            <template slot-scope="scope">
              <span class="approval" @click="look(scope.row)">{{scope.row.receiptNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cusName" label="客户/供应商名称">
            <template slot-scope="scope">
              <span class="approval" @click="goCustomerDetails(scope.row)">{{scope.row.cusName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="billNumber" label="承兑票号"></el-table-column>
          <el-table-column prop="billMoney" label="票据金额">
            <template v-slot="{ row }">{{row.billMoney | toFixed}}</template>
          </el-table-column>
          <el-table-column prop="billCompany" label="出票单位"></el-table-column>
          <el-table-column prop="billBank" label="出票行"></el-table-column>
          <el-table-column prop="billDate" label="出票日期">
            <template slot-scope="scope">{{ scope.row.billDate | dateFilterD }}</template>
          </el-table-column>
          <el-table-column prop="billEnddate" label="到期日期">
            <template slot-scope="scope">{{ scope.row.billEnddate | dateFilterD }}</template>
          </el-table-column>
          <el-table-column prop="receiptType" label="收款类型"></el-table-column>
          <el-table-column prop="receiptClass" label="收款方式"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <span>{{ scope.row.cstate | state }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUser" label="提交人"></el-table-column>
          <el-table-column prop="createDate" label="提交时间">
            <template slot-scope="scope">{{ scope.row.createDate | dateFilter }}</template>
          </el-table-column>
          <el-table-column prop="processUser" :key="8" label="认领人" v-if="activeName === '1'">
            <template v-slot="{row}">{{row.processUser || '--'}}</template>
          </el-table-column>
          <el-table-column prop="processDate" :key="9" label="认领时间" v-if="activeName !== '3'">
            <template slot-scope="scope">{{ scope.row.processDate | dateFilter }}</template>
          </el-table-column>
          <el-table-column prop="processDate" label="处理时间" v-if="activeName==='3'">
            <template slot-scope="scope">{{ scope.row.processDate | dateFilterD }}</template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" v-if="activeName==='1' ">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.extract === 1" @click="toClaim(scope.row)">认领</el-button>
              <el-button type="text" v-if="scope.row.extract === 2" @click="approval(scope.row)">处理</el-button>
              <el-button type="text" v-if="scope.row.extract === 3" @click="ondraw(scope.row)">提取</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" v-if="activeName==='2'">
            <template slot-scope="scope">
              <el-button type="text" @click="approval(scope.row)">处理</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" v-if="activeName==='3'">
            <template slot-scope="scope">
              <el-button type="text" @click="look(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <open-or-close
      @onUpdataState="onUpdataState"
      content="确认是否批量认领？"
      title="提示"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { isSuccess } from '@/util/tool'
import { acceeptList, bankDrafmonery } from '../financeManage/util/data'
import {
  queryAcceptanceBillListByState,
  updateStateByFbrIdClaimAll,
  updateStateByFbrIdstate
} from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'
import { mapState } from 'vuex'

export default {
  components: {
    'open-or-close': OpenOrClose,
    pagination: pagination,
    financeSeach
  },

  data() {
    return {
      miState: 0, // 列表状态
      activeName: '', // tabs选中状态
      acceeptList: acceeptList, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      queryParams: {}, // 搜索条件
      params: {},
      bankDrafmonery: bankDrafmonery, // 筛选条件
      expressionList: expressionList,
      checked: false,
      time: [],
      preParams: '',
      checkedList: []
    }
  },
  computed: {
    ...mapState(['financeTableHeight'])
  },
  mounted() {
    this.activeName = '1'
    this.getList()
  },
  watch: {
    checked(newVal) {
      clearInterval(this.timer)
      if (newVal) {
        this.timer = setInterval(() => {
          this.getList()
        }, 60000)
      }
      return newVal
    },
    activeName(newVal) {
      switch (newVal) {
        case '1':
        case '2':
          this.bankDrafmonery = [...bankDrafmonery]
          break
        case '3':
          this.bankDrafmonery = [
            ...bankDrafmonery,
            {
              label: '状态',
              value: 'cstate'
            },
            {
              label: '处理时间',
              value: 'processDate'
            }
          ]
          break
      }
      return newVal
    }
  },
  filters: {
    billState(billState) {
      if (billState === 1) {
        return '未使用'
      } else if (billState === 2) {
        return '已使用'
      } else if (billState === 3) {
        return '已提现'
      } else if (billState === 4) {
        return '已作废'
      }
    },
    state(state) {
      if (state === 1) {
        return '收款审核'
      } else if (state === 2) {
        return '收款成功'
      } else if (state === 3) {
        return '收款审核不通过'
      }
    }
  },
  methods: {
    selectableFun(row) {
      if (this.activeName === '1') {
        return row.extract === 1
      }
    },
    onUpdataState() {
      updateStateByFbrIdClaimAll(this.checkedList).then((res) => {
        if (isSuccess(res)) {
          this.$message.success('认领成功')
          this.getList()
        }
      })
    },
    onBatch() {
      if (this.checkedList.length > 0) {
        this.$refs.openOrCloseRefs.onInitial()
      } else {
        this.$message.error('请选择一条或多条！')
      }
    },
    handleSelectionChange(val) {
      // 多选
      this.checkedList = val
    },
    toClaim(row) {
      updateStateByFbrIdstate(1, 2, row, 'updateStateByFbrIdClaim').then((res) => {
        if (isSuccess(res)) {
          this.$message.success('认领成功')
          this.getList()
        }
      })
    },
    // 提取
    ondraw(row) {
      updateStateByFbrIdstate(1, 1, row, 'updateStateByFbrIdExtract')
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('提取成功！')
            this.getList()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 搜索
    onSearch() {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }

      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.getList()
      }
    },
    // 重置
    searchReset() {
      this.params = {}
      this.queryParams = {}
      this.getList()
    },
    // 处理
    approval(row) {
      this.$router.push({
        name: 'dealwith',
        query: { fabrId: row.id }
      })
    },
    // 查看
    look(row) {
      if (this.activeName !== '3') {
        this.$router.push({
          name: 'billLook',
          query: { fabrId: row.id }
        })
      } else {
        this.$router.push({
          name: 'passlook',
          query: { fabrId: row.id }
        })
      }
    },
    // tabs切换时触发的事件
    handleClick(tab) {
      this.activeName = tab.name
      this.$refs.clearSeachInfo.innerInit()
      this.getList()
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList(list) {
      this.loadingTable = true
      if (this.activeName === '1') {
        this.miState = 1
      } else if (this.activeName === '2') {
        this.miState = 2
      } else if (this.activeName === '3') {
        this.miState = 3
      }
      const params = {
        criteriaVoList: list || this.preParams || [],
        queryPageName: ''
      }
      if (list) {
        this.currentPage = 1
      }
      queryAcceptanceBillListByState(this.miState, this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.preParams = list
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    goCustomerDetails(row) {
      if (row.cusId) {
        this.$router.push({ name: 'customer/details', query: { id: row.cusId } })
      } else {
        this.$router.push({
          path: '/crm/supplier/supplierEdit',
          query: { id: row.suId }
        })
      }
    }
  }
}
</script>
